import { render, staticRenderFns } from "./DeleteLessonFromCourseConfirmationDialog.vue?vue&type=template&id=f814f5b4"
import script from "./DeleteLessonFromCourseConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteLessonFromCourseConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports